export const models = {
  HeaderModelOne: `
  
  <section data-ref="Section-8bc868db-95bb-422b-95c6-83927f00fc1c" id="iywqf">
  <div ref="Section-65a2654c-1592-49e9-9d9f-d8b07c1f0874" id="row-f3c2b85e-6ef0-45aa-a637-40aeb62aae37" data-auto="true" data-dot="false" data-nav="true" data-colordots="#000000" data-colordotshover="#000000" data-next="<i class=&quot;fa-solid fa-circle-chevron-right&quot;></i>" data-prev="<i class=&quot;fa-solid fa-circle-chevron-left&quot;></i>" data-margin="20" data-nb_desktop="4" data-nb_tablette="2" data-nb_mobile="1" conteneur="YES" class="gjs-row container mx-auto">
    <div id="ijbrk" class="gjs-cell">
      <div draggable="true" data-config="10,rotation" data-items="facebook,instagram" data-model-key="model_one" data-item-padding="{&quot;top&quot;:&quot;15&quot;,&quot;left&quot;:&quot;15&quot;,&quot;right&quot;:&quot;15&quot;,&quot;bottom&quot;:&quot;15&quot;}" data-item-margin="{&quot;top&quot;:&quot;0&quot;,&quot;left&quot;:&quot;0&quot;,&quot;right&quot;:&quot;0&quot;,&quot;bottom&quot;:&quot;0&quot;}" id="ixeli" class="social-gjs annimation-undefined">
        <a draggable="true" href="#" title="facebook" target="_blank"><svg draggable="true" viewBox="0 0 6.82666 6.82666" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Layer_x0020_1" draggable="true">
            <rect id="i0izp" draggable="true" height="6.82667" rx="1.45635" ry="1.45635" width="6.82667" class="fb-square">
            </rect>
            <path id="ikcxj" draggable="true" d="M4.19658 3.51299l-0.546957 0 0 2.00372 -0.82865 0 0 -2.00372 -0.394118 0 0 -0.704406 0.394118 0 0 -0.45565c0,-0.325795 0.154697,-0.83622 0.836161,-0.83622l0.613618 0.00265354 0 0.683575 -0.445252 0c-0.0731693,0 -0.175878,0.0365512 -0.175878,0.19187l0 0.414602 0.619563 0 -0.0726063 0.703575z" class="fb-font">
            </path>
          </g>
          </svg></a>
        <a id="i47mx" draggable="true" href="#" title="instagram " target="_blank"><svg id="inp2k" draggable="true" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs id="ijmsv" draggable="true">
            <radialGradient id="radial-gradient" draggable="true" cx="-578.95" cy="-837.6" gradientTransform="translate(499.5 629.5) scale(0.75)" gradientUnits="userSpaceOnUse" r="197.06">
              <stop id="iuqi6" draggable="true" offset="0" stop-color="#f9ed32">
              </stop>
              <stop id="ierou" draggable="true" offset="0.36" stop-color="#ee2a7b">
              </stop>
              <stop id="i9zcl" draggable="true" offset="0.44" stop-color="#d22a8a">
              </stop>
              <stop id="ix2uv" draggable="true" offset="0.6" stop-color="#8b2ab2">
              </stop>
              <stop id="ir6me" draggable="true" offset="0.83" stop-color="#1b2af0">
              </stop>
              <stop id="i7y7q" draggable="true" offset="0.88" stop-color="#002aff">
              </stop>
            </radialGradient>
          </defs>
          <title id="i9kg1" draggable="true">
          </title>
          <g id="_3-instagram" draggable="true" data-name="3-instagram">
            <rect id="i1vny" draggable="true" height="64" rx="11.2" ry="11.2" transform="translate(64 64) rotate(180)" width="64" class="instagram-square">
            </rect>
            <path id="iegt9" draggable="true" d="M44,56H20A12,12,0,0,1,8,44V20A12,12,0,0,1,20,8H44A12,12,0,0,1,56,20V44A12,12,0,0,1,44,56ZM20,12.8A7.21,7.21,0,0,0,12.8,20V44A7.21,7.21,0,0,0,20,51.2H44A7.21,7.21,0,0,0,51.2,44V20A7.21,7.21,0,0,0,44,12.8Z" class="instagram-font">
            </path>
            <path id="ij5ee" draggable="true" d="M32,45.6A13.6,13.6,0,1,1,45.6,32,13.61,13.61,0,0,1,32,45.6Zm0-22.4A8.8,8.8,0,1,0,40.8,32,8.81,8.81,0,0,0,32,23.2Z" class="instagram-font">
            </path>
            <circle id="i7gfn" draggable="true" cx="45.6" cy="19.2" r="2.4" class="instagram-font">
            </circle>
          </g>
          </svg></a>
      </div>
    </div>
    <div id="i6knc" class="gjs-cell">
      <a href="tel:102030405" title="" id="i3xkg" class="appel-gjs"><i class="fas fa-mobile-alt">
        </i><span class="gjs-appel-phone">102030405</span> </a>
    </div>
  </div>
</section>
<section data-ref="Section-8bc868db-95bb-422b-95c6-83927f00fc1c" id="it1ch">
  <div ref="Section-65a2654c-1592-49e9-9d9f-d8b07c1f0874" id="row-a410ba80-90df-4394-9ccc-dcbcd2a501b2" data-auto="true" data-dot="false" data-nav="true" data-colordots="#000000" data-colordotshover="#000000" data-next="<i class=&quot;fa-solid fa-circle-chevron-right&quot;></i>" data-prev="<i class=&quot;fa-solid fa-circle-chevron-left&quot;></i>" data-margin="20" data-nb_desktop="4" data-nb_tablette="2" data-nb_mobile="1" conteneur="YES" class="gjs-row container mx-auto">
    <div id="i9vng" class="gjs-cell">
      <a title="" id="logo-e445509c-a9dd-4fc7-bb63-d09626b1d895" href="/" class="logo-gjs"><img id="img-logo-e445509c-a9dd-4fc7-bb63-d09626b1d895" alt="" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImZpbGw6IHJnYmEoMCwwLDAsMC4xNSk7IHRyYW5zZm9ybTogc2NhbGUoMC43NSkiPgogICAgICAgIDxwYXRoIGQ9Ik0yLjI4IDNMMSA0LjI3bDIgMlYxOWMwIDEuMS45IDIgMiAyaDEyLjczbDIgMkwyMSAyMS43MiAyLjI4IDNtMi41NSAwTDIxIDE5LjE3VjVhMiAyIDAgMCAwLTItMkg0LjgzTTguNSAxMy41bDIuNSAzIDEtMS4yNUwxNC43MyAxOEg1bDMuNS00LjV6Ij48L3BhdGg+CiAgICAgIDwvc3ZnPg==" class="logo-img"/></a>
    </div>
    <div id="igpo3" class="gjs-cell">
      <div data-model="horizontal" id="ixod7" data-bg="rgb(0 0 0 / 0%)" data-seperator-color="#000" data-raduis="{&quot;topLeft&quot;:&quot;0&quot;,&quot;topRight&quot;:&quot;0&quot;,&quot;bottomLeft&quot;:&quot;0&quot;,&quot;bottomRight&quot;:&quot;0&quot;}" data-padding="{&quot;top&quot;:&quot;15&quot;,&quot;left&quot;:&quot;15&quot;,&quot;right&quot;:&quot;15&quot;,&quot;bottom&quot;:&quot;15&quot;}" data-margin="{&quot;top&quot;:&quot;0&quot;,&quot;left&quot;:&quot;0&quot;,&quot;right&quot;:&quot;0&quot;,&quot;bottom&quot;:&quot;0&quot;}" data-survol-text="rgb(0, 0, 0,1)" data-survol-bg="#000000" data-bg-submenu="#eeeeee" data-padding-submenu="{&quot;top&quot;:&quot;15&quot;,&quot;left&quot;:&quot;15&quot;,&quot;right&quot;:&quot;15&quot;,&quot;bottom&quot;:&quot;15&quot;}" data-margin-submenu="{&quot;top&quot;:&quot;0&quot;,&quot;left&quot;:&quot;0&quot;,&quot;right&quot;:&quot;0&quot;,&quot;bottom&quot;:&quot;0&quot;}" data-survol-submenu-text="rgb(0, 0, 0,1)" data-survol-submenu-bg="#000000" data-style="stroke-effect" data-seperator="" data-align="start" data-logo-width="200px" class="gjs-navigation stroke-effect">
        <nav id="icwih" class="gjs-nav d-flex align-items-center">
          <ul class="navbar-nav flex-row flex-wrap">
            <li class="nav-item">
              <a id="653633c9411b2edaa44c5679" href="/" title="Accueil" target="_self" class="active"> Accueil</a>
            </li>
            <li class="nav-item dropdown"> 
              <a target="_blank" href="/qsdsqdsqd" id="sub-65377667411b2edaa44c6f84" aria-expanded="false" role="button" class="dropdown-toggle">qsdsqdsqd</a>
              <ul data-bs-popper="static" aria-labelledby="sub-65377667411b2edaa44c6f84" class="dropdown-menu submenu-one border-0">
                <li class="nav-item dropdown dropend">
                  <a href="/dsfdsf" id="sub-6537766a411b2edaa44c6f99" aria-expanded="false" role="button" target="_self" class="dropdown-item dropdown-toggle submenu">dsfdsf qsdsqdsqdsq sqdsqdsqqsdsqdsq</a>
                  <ul data-bs-popper="static" aria-labelledby="sub-6537766a411b2edaa44c6f99" class="dropdown-menu submenu-two border-0">
                    <li class="nav-item">
                      <a href="/sdsqdsdqd" title="sdsqdsdqd" target="_blank" class="dropdown-item"> 
                        sdsqdsdqd </a> 
                    </li>
                  </ul>
                </li> 
                <li class="nav-item">
                  <a target="_self" href="/sdfdsfsd" title="sdfdsfsd" class="dropdown-item"> 
                    sdfdsfsd </a> 
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</section>
    <style>
    #row-f3c2b85e-6ef0-45aa-a637-40aeb62aae37 .owl-theme .owl-dots .owl-dot span{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #row-f3c2b85e-6ef0-45aa-a637-40aeb62aae37 .owl-theme .owl-dots .owl-dot.active span, .owl-theme .owl-dots .owl-dot:hover span{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    .fb-square{
      fill:rgb(25, 118, 210);
    }
    .fb-font{
      fill:rgb(255, 255, 255);
    }
    .instagram-square{
      fill:url("#radial-gradient");
    }
    .instagram-font{
      fill:rgb(255, 255, 255);
    }
    .appel-gjs i{
      margin-right:10px;
    }
    .appel-gjs{
      display:flex;
      align-items:center;
      text-decoration-line:none;
      text-decoration-thickness:initial;
      text-decoration-style:initial;
      text-decoration-color:initial;
    }
    #row-a410ba80-90df-4394-9ccc-dcbcd2a501b2 .owl-theme .owl-dots .owl-dot span{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #row-a410ba80-90df-4394-9ccc-dcbcd2a501b2 .owl-theme .owl-dots .owl-dot.active span, .owl-theme .owl-dots .owl-dot:hover span{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul li::before{
      color:rgb(0, 0, 0);
    }
    #ixod7 ul li a{
      border-top-left-radius:0%;
      border-top-right-radius:0%;
      border-bottom-left-radius:0%;
      border-bottom-right-radius:0%;
      padding-top:15px;
      padding-bottom:15px;
      padding-right:15px;
      padding-left:15px;
      margin-top:0px;
      margin-bottom:0px;
      margin-right:0px;
      margin-left:0px;
    }
    #ixod7 ul li a:hover{
      color:rgb(0, 0, 0);
    }
    #ixod7 ul li a.active{
      color:rgb(0, 0, 0);
    }
    #ixod7 ul li a:hover::after{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul li a:hover::before{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul li a.active::after{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul li a.active::before{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul.dropdown-menu{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(238, 238, 238);
    }
    #ixod7 ul.dropdown-menu li a{
      padding-top:15px;
      padding-bottom:15px;
      padding-right:15px;
      padding-left:15px;
      margin-top:0px;
      margin-bottom:0px;
      margin-right:0px;
      margin-left:0px;
    }
    #ixod7 ul.dropdown-menu li a:hover{
      color:rgb(0, 0, 0);
    }
    #ixod7 ul.dropdown-menu li a.active{
      color:rgb(0, 0, 0);
    }
    #ixod7 ul.dropdown-menu li a:hover::after{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul.dropdown-menu li a:hover::before{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul.dropdown-menu li a.active::after{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul.dropdown-menu li a.active::before{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }

    #iywqf{
      padding-top:0px;
      padding-right:0px;
      padding-bottom:0px;
      padding-left:0px;
    }
    #row-f3c2b85e-6ef0-45aa-a637-40aeb62aae37{
      padding-top:0px;
      padding-right:0px;
      padding-bottom:0px;
      padding-left:0px;
    }
    #ijbrk{
      width:50%;
      padding-top:0px;
      padding-right:0px;
      padding-bottom:0px;
      padding-left:0px;
      vertical-align:middle;
    }
    #ixeli{
      display:flex;
      justify-content:flex-start;
    }
    #i6knc{
      width:50%;
      padding-top:0px;
      padding-right:0px;
      padding-bottom:0px;
      padding-left:0px;
      text-align:right;
      vertical-align:middle;
    }
    #i3xkg{
      display:inline-block;
      font-size:20px;
    }
    #it1ch{
      padding-top:0px;
      padding-right:0px;
      padding-bottom:0px;
      padding-left:0px;
    }
    #row-a410ba80-90df-4394-9ccc-dcbcd2a501b2{
      padding-top:0px;
      padding-right:0px;
      padding-bottom:0px;
      padding-left:0px;
    }
    #i9vng{
      width:15%;
      padding-top:0px;
      padding-right:0px;
      padding-bottom:0px;
      padding-left:0px;
    }
    #logo-e445509c-a9dd-4fc7-bb63-d09626b1d895{
      position:relative;
      width:auto;
      height:auto;
    }
    #igpo3{
      width:85%;
    }
    #ixod7{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(255, 255, 255 ,0%);
      display:flex !important;
      justify-content:start !important;
    }
    #ixod7 ul li::before{
      color:rgb(0, 0, 0);
    }
    #ixod7 ul li a:hover::after{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul li a:hover::before{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul li a.active::after{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul li a.active::before{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul.dropdown-menu li a:hover::after{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul.dropdown-menu li a:hover::before{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul.dropdown-menu li a.active::after{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    #ixod7 ul.dropdown-menu li a.active::before{
      background-image:initial;
      background-position-x:initial;
      background-position-y:initial;
      background-size:initial;
      background-repeat-x:initial;
      background-repeat-y:initial;
      background-attachment:initial;
      background-origin:initial;
      background-clip:initial;
      background-color:rgb(0, 0, 0);
    }
    
    </style>
`,
  HeaderModelTwo: `
  <section data-ref="Section-8bc868db-95bb-422b-95c6-83927f00fc1c" id="iywqf">
  <div ref="Section-65a2654c-1592-49e9-9d9f-d8b07c1f0874" id="row-f3c2b85e-6ef0-45aa-a637-40aeb62aae37" data-auto="true" data-dot="false" data-nav="true" data-colordots="#000000" data-colordotshover="#000000" data-next="<i class=&quot;fa-solid fa-circle-chevron-right&quot;></i>" data-prev="<i class=&quot;fa-solid fa-circle-chevron-left&quot;></i>" data-margin="20" data-nb_desktop="4" data-nb_tablette="2" data-nb_mobile="1" conteneur="NO" class="gjs-row">
    <div id="ijbrk" class="gjs-cell">
      <div draggable="true" data-config="10,rotation" data-items="facebook,instagram" data-model-key="model_one" data-item-padding="{&quot;top&quot;:&quot;0&quot;,&quot;left&quot;:&quot;0&quot;,&quot;right&quot;:&quot;0&quot;,&quot;bottom&quot;:&quot;0&quot;}" data-item-margin="{&quot;top&quot;:&quot;0&quot;,&quot;left&quot;:&quot;0&quot;,&quot;right&quot;:&quot;0&quot;,&quot;bottom&quot;:&quot;0&quot;}" id="ixeli" class="social-gjs  annimation-rotation">
        <a href="#" title="facebook" target="_blank"><svg viewBox="0 0 6.82666 6.82666" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="ig3q5">
          <g id="Layer_x0020_1">
            <rect height="6.82667" rx="1.45635" ry="1.45635" width="6.82667" id="iz2ji">
            </rect>
            <path d="M4.19658 3.51299l-0.546957 0 0 2.00372 -0.82865 0 0 -2.00372 -0.394118 0 0 -0.704406 0.394118 0 0 -0.45565c0,-0.325795 0.154697,-0.83622 0.836161,-0.83622l0.613618 0.00265354 0 0.683575 -0.445252 0c-0.0731693,0 -0.175878,0.0365512 -0.175878,0.19187l0 0.414602 0.619563 0 -0.0726063 0.703575z" id="i6ecs">
            </path>
          </g>
          </svg></a>
        <a href="#" title="instagram " target="_blank"><svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <radialGradient cx="-578.95" cy="-837.6" gradientTransform="translate(499.5 629.5) scale(0.75)" gradientUnits="userSpaceOnUse" id="radial-gradient" r="197.06">
              <stop offset="0" stop-color="#f9ed32">
              </stop>
              <stop offset="0.36" stop-color="#ee2a7b">
              </stop>
              <stop offset="0.44" stop-color="#d22a8a">
              </stop>
              <stop offset="0.6" stop-color="#8b2ab2">
              </stop>
              <stop offset="0.83" stop-color="#1b2af0">
              </stop>
              <stop offset="0.88" stop-color="#002aff">
              </stop>
            </radialGradient>
          </defs>
          <title>
          </title>
          <g data-name="3-instagram" id="_3-instagram">
            <rect height="64" rx="11.2" ry="11.2" transform="translate(64 64) rotate(180)" width="64" id="imjtq">
            </rect>
            <path d="M44,56H20A12,12,0,0,1,8,44V20A12,12,0,0,1,20,8H44A12,12,0,0,1,56,20V44A12,12,0,0,1,44,56ZM20,12.8A7.21,7.21,0,0,0,12.8,20V44A7.21,7.21,0,0,0,20,51.2H44A7.21,7.21,0,0,0,51.2,44V20A7.21,7.21,0,0,0,44,12.8Z" id="i2hu1">
            </path>
            <path d="M32,45.6A13.6,13.6,0,1,1,45.6,32,13.61,13.61,0,0,1,32,45.6Zm0-22.4A8.8,8.8,0,1,0,40.8,32,8.81,8.81,0,0,0,32,23.2Z" id="ion48">
            </path>
            <circle cx="45.6" cy="19.2" r="2.4" id="iwbjy">
            </circle>
          </g>
          </svg></a>
      </div>
    </div>
    <div id="i6knc" class="gjs-cell">
      <a href="tel:102030405" title="" id="i3xkg" class="appel-gjs"><i class="fas fa-mobile-alt">
        </i><span class="gjs-appel-phone">102030405</span> </a>
    </div>
  </div>
</section>
<section data-ref="Section-8bc868db-95bb-422b-95c6-83927f00fc1c" id="it1ch">
  <div ref="Section-65a2654c-1592-49e9-9d9f-d8b07c1f0874" id="row-a410ba80-90df-4394-9ccc-dcbcd2a501b2" data-auto="true" data-dot="false" data-nav="true" data-colordots="#000000" data-colordotshover="#000000" data-next="<i class=&quot;fa-solid fa-circle-chevron-right&quot;></i>" data-prev="<i class=&quot;fa-solid fa-circle-chevron-left&quot;></i>" data-margin="20" data-nb_desktop="4" data-nb_tablette="2" data-nb_mobile="1" conteneur="NO" class="gjs-row">
    <div id="i9vng" class="gjs-cell">
      <a title="" id="logo-e445509c-a9dd-4fc7-bb63-d09626b1d895" href="/" class="logo-gjs"><img id="img-logo-e445509c-a9dd-4fc7-bb63-d09626b1d895" alt="" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImZpbGw6IHJnYmEoMCwwLDAsMC4xNSk7IHRyYW5zZm9ybTogc2NhbGUoMC43NSkiPgogICAgICAgIDxwYXRoIGQ9Ik0yLjI4IDNMMSA0LjI3bDIgMlYxOWMwIDEuMS45IDIgMiAyaDEyLjczbDIgMkwyMSAyMS43MiAyLjI4IDNtMi41NSAwTDIxIDE5LjE3VjVhMiAyIDAgMCAwLTItMkg0LjgzTTguNSAxMy41bDIuNSAzIDEtMS4yNUwxNC43MyAxOEg1bDMuNS00LjV6Ij48L3BhdGg+CiAgICAgIDwvc3ZnPg==" class="logo-img"/></a>
    </div>
    <div id="igpo3" class="gjs-cell">
      <div data-model="horizontal" id="ixod7" class="gjs-navigation fill-effect">
        <nav id="icwih" class="gjs-nav d-flex align-items-center">
          <ul class="navbar-nav flex-row flex-wrap">
            <li class="nav-item">
              <a id="653633c9411b2edaa44c5679" href="/" title="Accueil" target="_self" class="active"> Accueil</a>
            </li>
            <li class="nav-item dropdown"> 
              <a target="_blank" href="/qsdsqdsqd" id="sub-65377667411b2edaa44c6f84" aria-expanded="false" role="button" class="dropdown-toggle">qsdsqdsqd</a>
              <ul data-bs-popper="static" aria-labelledby="sub-65377667411b2edaa44c6f84" class="dropdown-menu submenu-one border-0">
                <li class="nav-item dropdown dropend">
                  <a href="/dsfdsf" id="sub-6537766a411b2edaa44c6f99" aria-expanded="false" role="button" target="_self" class="dropdown-item dropdown-toggle submenu">dsfdsf qsdsqdsqdsq sqdsqdsqqsdsqdsq</a>
                  <ul data-bs-popper="static" aria-labelledby="sub-6537766a411b2edaa44c6f99" class="dropdown-menu submenu-two border-0">
                    <li class="nav-item">
                      <a href="/sdsqdsdqd" title="sdsqdsdqd" target="_blank" class="dropdown-item"> 
                        sdsqdsdqd </a> 
                    </li>
                  </ul>
                </li> 
                <li class="nav-item">
                  <a target="_self" href="/sdfdsfsd" title="sdfdsfsd" class="dropdown-item"> 
                    sdfdsfsd </a> 
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
  <style>
#row-f3c2b85e-6ef0-45aa-a637-40aeb62aae37 .owl-theme .owl-dots .owl-dot span{
   background-image:initial;
   background-position-x:initial;
   background-position-y:initial;
   background-size:initial;
   background-repeat-x:initial;
   background-repeat-y:initial;
   background-attachment:initial;
   background-origin:initial;
   background-clip:initial;
   background-color:rgb(0, 0, 0);
 }
 #row-f3c2b85e-6ef0-45aa-a637-40aeb62aae37 .owl-theme .owl-dots .owl-dot.active span, .owl-theme .owl-dots .owl-dot:hover span{
   background-image:initial;
   background-position-x:initial;
   background-position-y:initial;
   background-size:initial;
   background-repeat-x:initial;
   background-repeat-y:initial;
   background-attachment:initial;
   background-origin:initial;
   background-clip:initial;
   background-color:rgb(0, 0, 0);
 }
 .appel-gjs i{
   margin-right:10px;
 }
 .appel-gjs{
   display:flex;
   align-items:center;
   text-decoration-line:none;
   text-decoration-thickness:initial;
   text-decoration-style:initial;
   text-decoration-color:initial;
 }
 #row-a410ba80-90df-4394-9ccc-dcbcd2a501b2 .owl-theme .owl-dots .owl-dot span{
   background-image:initial;
   background-position-x:initial;
   background-position-y:initial;
   background-size:initial;
   background-repeat-x:initial;
   background-repeat-y:initial;
   background-attachment:initial;
   background-origin:initial;
   background-clip:initial;
   background-color:rgb(0, 0, 0);
 }
 #row-a410ba80-90df-4394-9ccc-dcbcd2a501b2 .owl-theme .owl-dots .owl-dot.active span, .owl-theme .owl-dots .owl-dot:hover span{
   background-image:initial;
   background-position-x:initial;
   background-position-y:initial;
   background-size:initial;
   background-repeat-x:initial;
   background-repeat-y:initial;
   background-attachment:initial;
   background-origin:initial;
   background-clip:initial;
   background-color:rgb(0, 0, 0);
 }
 #ixod7 ul li::before{
   color:rgb(0, 0, 0);
 }
 #ixod7 ul li a{
   border-top-left-radius:0%;
   border-top-right-radius:0%;
   border-bottom-left-radius:0%;
   border-bottom-right-radius:0%;
   padding-top:15px;
   padding-bottom:15px;
   padding-right:15px;
   padding-left:15px;
   margin-top:0px;
   margin-bottom:0px;
   margin-right:0px;
   margin-left:0px;
 }
 #ixod7 ul li a:hover{
   color:rgb(255, 255, 255);
 }
 #ixod7 ul li a.active{
   color:rgb(255, 255, 255);
 }
 #ixod7 ul li a:hover::after{
   background-image:initial;
   background-position-x:initial;
   background-position-y:initial;
   background-size:initial;
   background-repeat-x:initial;
   background-repeat-y:initial;
   background-attachment:initial;
   background-origin:initial;
   background-clip:initial;
   background-color:rgb(0, 0, 0);
 }
 #ixod7 ul li a:hover::before{
   background-image:initial;
   background-position-x:initial;
   background-position-y:initial;
   background-size:initial;
   background-repeat-x:initial;
   background-repeat-y:initial;
   background-attachment:initial;
   background-origin:initial;
   background-clip:initial;
   background-color:rgb(0, 0, 0);
 }
 #ixod7 ul li a.active::after{
   background-image:initial;
   background-position-x:initial;
   background-position-y:initial;
   background-size:initial;
   background-repeat-x:initial;
   background-repeat-y:initial;
   background-attachment:initial;
   background-origin:initial;
   background-clip:initial;
   background-color:rgb(0, 0, 0);
 }
 #ixod7 ul li a.active::before{
   background-image:initial;
   background-position-x:initial;
   background-position-y:initial;
   background-size:initial;
   background-repeat-x:initial;
   background-repeat-y:initial;
   background-attachment:initial;
   background-origin:initial;
   background-clip:initial;
   background-color:rgb(0, 0, 0);
 }
 #ixod7 ul.dropdown-menu{
   background-image:initial;
   background-position-x:initial;
   background-position-y:initial;
   background-size:initial;
   background-repeat-x:initial;
   background-repeat-y:initial;
   background-attachment:initial;
   background-origin:initial;
   background-clip:initial;
   background-color:rgb(238, 238, 238);
 }
 #ixod7 ul.dropdown-menu li a{
   padding-top:15px;
   padding-bottom:15px;
   padding-right:15px;
   padding-left:15px;
   margin-top:0px;
   margin-bottom:0px;
   margin-right:0px;
   margin-left:0px;
 }
 #ixod7 ul.dropdown-menu li a:hover{
   color:rgb(255, 255, 255);
 }
 #ixod7 ul.dropdown-menu li a.active{
   color:rgb(255, 255, 255);
 }
 #ixod7 ul.dropdown-menu li a:hover::after{
   background-image:initial;
   background-position-x:initial;
   background-position-y:initial;
   background-size:initial;
   background-repeat-x:initial;
   background-repeat-y:initial;
   background-attachment:initial;
   background-origin:initial;
   background-clip:initial;
   background-color:rgb(0, 0, 0);
 }
 #ixod7 ul.dropdown-menu li a:hover::before{
   background-image:initial;
   background-position-x:initial;
   background-position-y:initial;
   background-size:initial;
   background-repeat-x:initial;
   background-repeat-y:initial;
   background-attachment:initial;
   background-origin:initial;
   background-clip:initial;
   background-color:rgb(0, 0, 0);
 }
 #ixod7 ul.dropdown-menu li a.active::after{
   background-image:initial;
   background-position-x:initial;
   background-position-y:initial;
   background-size:initial;
   background-repeat-x:initial;
   background-repeat-y:initial;
   background-attachment:initial;
   background-origin:initial;
   background-clip:initial;
   background-color:rgb(0, 0, 0);
 }
 #ixod7 ul.dropdown-menu li a.active::before{
   background-image:initial;
   background-position-x:initial;
   background-position-y:initial;
   background-size:initial;
   background-repeat-x:initial;
   background-repeat-y:initial;
   background-attachment:initial;
   background-origin:initial;
   background-clip:initial;
   background-color:rgb(0, 0, 0);
 }

 #iywqf{
   padding-top:10px;
   padding-right:0px;
   padding-bottom:10px;
   padding-left:0px;
   background-color:rgb(64, 64, 64);
 }
 #row-f3c2b85e-6ef0-45aa-a637-40aeb62aae37{
   padding-top:0px;
   padding-right:0px;
   padding-bottom:0px;
   padding-left:5px;
 }
 #ijbrk{
   width:50%;
   padding-top:0px;
   padding-right:0px;
   padding-bottom:0px;
   padding-left:0px;
   vertical-align:middle;
 }
 #ixeli{
   display:flex;
   justify-content:flex-start;
 }
 #i6knc{
   width:50%;
   text-align:right;
   vertical-align:middle;
   padding:0px 10px 0px 0px;
 }
 #i3xkg{
   display:inline-block;
   font-size:20px;
 }
 #it1ch{
   padding-top:0px;
   padding-right:0px;
   padding-bottom:0px;
   padding-left:0px;
 }
 #row-a410ba80-90df-4394-9ccc-dcbcd2a501b2{
   padding-top:0px;
   padding-right:0px;
   padding-bottom:0px;
   padding-left:0px;
 }
 #i9vng{
   width:15%;
 }
 #logo-e445509c-a9dd-4fc7-bb63-d09626b1d895{
   position:relative;
   width:auto;
   height:auto;
 }
 #igpo3{
   width:85%;
 }
 #ixeli.social-gjs a, #ixeli a{
   margin:0px 10px;
 }
 #ixeli, #ixeli.social-gjs{
   padding-top:0px;
   padding-bottom:0px;
   padding-right:0px;
   padding-left:0px;
   margin-top:0px;
   margin-bottom:0px;
   margin-right:0px;
   margin-left:0px;
 }
 #ig3q5{
   shape-rendering:geometricPrecision;
   text-rendering:geometricPrecision;
   image-rendering:optimizeQuality;
   fill-rule:evenodd;
   clip-rule:evenodd;
 }
 #iz2ji{
   fill:#1976D2;
 }
 #i6ecs{
   fill:white;
 }
 #imjtq{
   fill:url(#radial-gradient);
 }
 #i2hu1{
   fill:#fff;
 }
 #ion48{
   fill:#fff;
 }
 #iwbjy{
   fill:#fff;
 }
 
</style>
</section>

`,
  HeaderModelThree: `
  <section data-ref="Section-25b5dc84-5878-4e62-9808-143b3da790ed">
  <div ref="Section-7f73c12a-772c-47c7-9b36-23eafb89d82a" id="row-4cfd61d6-08dd-42a3-b8fa-33a73aa7bfa8" data-auto="true" data-dot="false" data-nav="true" data-colordots="#000000" data-colordotshover="#000000" data-next="<i class=&quot;fa-solid fa-circle-chevron-right&quot;></i>" data-prev="<i class=&quot;fa-solid fa-circle-chevron-left&quot;></i>" data-margin="20" data-nb_desktop="4" data-nb_tablette="2" data-nb_mobile="1" class="gjs-row">
    <div id="i3mc" class="gjs-cell">
      <div title="" id="i4od7" class="adresse-gjs">
        <i id="icon-a008f651-9f02-432e-b23a-06918c3a2739" class="fas fa-map-marker-alt">
        </i>
        <span id="iohdr" class="gjs-adress-text">7 Rue de l'Énergie, 55</span>
      </div>
      <a href="tel:102030405" title="" id="imh2x" class="appel-gjs"><i class="fas fa-mobile-alt">
        </i><span id="i1myg" class="gjs-appel-phone">102030405</span> </a>
    </div>
    <div id="ibzf" class="gjs-cell">
    <a data-gjs-highlightable="true" id="logo-dbe123f4-db7e-4622-aab0-3c224070ae69" data-gjs-type="logo" draggable="true" title="147966-tamara-leclercq" href="/" class="logo-gjs ">      <img id="img-logo-5d718a22-2ac0-4312-9def-99ef6b78c7db" alt="" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImZpbGw6IHJnYmEoMCwwLDAsMC4xNSk7IHRyYW5zZm9ybTogc2NhbGUoMC43NSkiPgogICAgICAgIDxwYXRoIGQ9Ik0yLjI4IDNMMSA0LjI3bDIgMlYxOWMwIDEuMS45IDIgMiAyaDEyLjczbDIgMkwyMSAyMS43MiAyLjI4IDNtMi41NSAwTDIxIDE5LjE3VjVhMiAyIDAgMCAwLTItMkg0LjgzTTguNSAxMy41bDIuNSAzIDEtMS4yNUwxNC43MyAxOEg1bDMuNS00LjV6Ij48L3BhdGg+CiAgICAgIDwvc3ZnPg==" class="logo-img"/>
    </a>
    </div>
    <div id="il2x" class="gjs-cell">
    <span id="il2x" class="sidebar-menu-toggle">
      <i id="icon-587a3193-a983-4926-a88e-8e1678f9de4e" class="icon-gjs fas fa-align-right ">
      </i>
    </span>
    </div>
  </div>
</section>
<section data-gjs-highlightable="true" id="iiyp" data-gjs-type="Sidebar" data-ref="Section-4759aee1-88c2-482c-a8a3-1b360748b3b7" data-ombre-color="#00000000" data-ombre-type="" data-ombre-size="" data-bg="#fff" class="sidebar-menu SidebarModelOne AnnimationRightToLeft active"><div data-gjs-highlightable="true" id="row-4d13e102-b0c4-486b-a026-b11151b642d9" data-gjs-type="Row" draggable="true" ref="Section-20a886a0-9b78-40f1-8ed7-5fafa3c2d42c" data-auto="true" data-dot="false" data-nav="true" data-colordots="#000000" data-colordotshover="#000000" data-next="<i class=&quot;fa-solid fa-circle-chevron-right&quot;></i>" data-prev="<i class=&quot;fa-solid fa-circle-chevron-left&quot;></i>" data-margin="20" data-nb_desktop="4" data-nb_tablette="2" data-nb_mobile="1" class="gjs-row"><div data-gjs-highlightable="true" id="i2di" data-gjs-type="Colonne" draggable="true" class="gjs-cell"><sapn data-gjs-highlightable="true" id="iiw2g" data-gjs-type="default" draggable="true" class="sidebar-menu-close"><i data-gjs-highlightable="true" id="icon-3623c40e-da48-45e3-8765-8139c77729a2" data-gjs-type="IconType" draggable="true" class="icon-gjs fas fa-times">
    </i></sapn></div></div><div data-gjs-highlightable="true" id="row-a4078714-6caf-453c-94ff-58d322768aa9" data-gjs-type="Row" draggable="true" ref="Section-20a886a0-9b78-40f1-8ed7-5fafa3c2d42c" data-auto="true" data-dot="false" data-nav="true" data-colordots="#000000" data-colordotshover="#000000" data-next="<i class=&quot;fa-solid fa-circle-chevron-right&quot;></i>" data-prev="<i class=&quot;fa-solid fa-circle-chevron-left&quot;></i>" data-margin="20" data-nb_desktop="4" data-nb_tablette="2" data-nb_mobile="1" class="gjs-row"><div data-gjs-highlightable="true" id="ixfbf" data-gjs-type="Colonne" draggable="true" class="gjs-cell"><div data-gjs-highlightable="true" id="irx2f" data-gjs-type="Navigation" draggable="true" data-model="vertical" data-bg="rgb(0 0 0 / 0%)" data-seperator-color="#000" data-raduis="{&quot;topLeft&quot;:&quot;0&quot;,&quot;topRight&quot;:&quot;0&quot;,&quot;bottomLeft&quot;:&quot;0&quot;,&quot;bottomRight&quot;:&quot;0&quot;}" data-padding="{&quot;top&quot;:&quot;15&quot;,&quot;left&quot;:&quot;0&quot;,&quot;right&quot;:&quot;30&quot;,&quot;bottom&quot;:&quot;15&quot;}" data-margin="{&quot;top&quot;:&quot;0&quot;,&quot;left&quot;:&quot;30&quot;,&quot;right&quot;:&quot;0&quot;,&quot;bottom&quot;:&quot;0&quot;}" data-survol-text="rgb(0, 0, 0,1)" data-survol-bg="#000000" data-bg-submenu="#eeeeee" data-padding-submenu="{&quot;top&quot;:&quot;15&quot;,&quot;left&quot;:&quot;15&quot;,&quot;right&quot;:&quot;15&quot;,&quot;bottom&quot;:&quot;15&quot;}" data-margin-submenu="{&quot;top&quot;:&quot;0&quot;,&quot;left&quot;:&quot;0&quot;,&quot;right&quot;:&quot;0&quot;,&quot;bottom&quot;:&quot;0&quot;}" data-survol-submenu-text="rgb(0, 0, 0,1)" data-survol-submenu-bg="#000000" data-style="stroke-effect" data-seperator="" data-align="center" data-logo-width="200px" data-font="unset" data-variant="normal" data-size="{&quot;desktop&quot;:&quot;20&quot;,&quot;tablet&quot;:&quot;14&quot;,&quot;mobile&quot;:&quot;14&quot;}" data-color="#000000" data-submenu-font="unset" data-submenu-variant="normal" data-submenu-size="{&quot;desktop&quot;:&quot;16&quot;,&quot;tablet&quot;:&quot;14&quot;,&quot;mobile&quot;:&quot;14&quot;}" data-submenu-color="#000000" data-submenu-align="left" class="gjs-navigation stroke-effect"><nav data-gjs-highlightable="true" id="irw0j" data-gjs-type="default" class="gjs-nav d-flex align-items-center"><ul data-gjs-highlightable="true" id="i5oug" data-gjs-type="MenuNav" draggable="true" class="navbar-nav flex-column"><li data-gjs-highlightable="true" id="ifvhy" data-gjs-type="MenuItem" draggable="true" class="nav-item"><a data-gjs-highlightable="true" id="651d20ed339e5ebc72f9b896" data-gjs-type="MenuNavLink" draggable="true" target="_self" href="/" title="Accueil" class="active"> Accueil</a></li></ul></nav></div></div></div><script class="">
  $(function(){
    $(".sidebar-menu-toggle").click(function(){
 
       $(".sidebar-menu").addClass("active");
    })
    $(".sidebar-menu-close").click(function(){
       $(".sidebar-menu").removeClass("active");
    })
 })
  </script></section>
      <style>
      #row-4cfd61d6-08dd-42a3-b8fa-33a73aa7bfa8 .owl-theme .owl-dots .owl-dot span{
         background-image:initial;
         background-position-x:initial;
         background-position-y:initial;
         background-size:initial;
         background-repeat-x:initial;
         background-repeat-y:initial;
         background-attachment:initial;
         background-origin:initial;
         background-clip:initial;
         background-color:rgb(0, 0, 0);
       }
       #row-4cfd61d6-08dd-42a3-b8fa-33a73aa7bfa8 .owl-theme .owl-dots .owl-dot.active span, .owl-theme .owl-dots .owl-dot:hover span{
         background-image:initial;
         background-position-x:initial;
         background-position-y:initial;
         background-size:initial;
         background-repeat-x:initial;
         background-repeat-y:initial;
         background-attachment:initial;
         background-origin:initial;
         background-clip:initial;
         background-color:rgb(0, 0, 0);
       }
       #i3mc{
         width:33%;
         vertical-align:middle;
         text-align:left;
       }
       #il2x{
         width:33%;
         text-align:right;
       }
       #ibzf{
         width:33%;
         text-align:center;
       }
       #logo-5d718a22-2ac0-4312-9def-99ef6b78c7db{
         position:relative;
         width:auto;
         height:auto;
       }
       #img-logo-5d718a22-2ac0-4312-9def-99ef6b78c7db{
         width:250px;
       }
       .adresse-gjs i{
         font-size:25px;
       }
       .appel-gjs{
         display:flex;
         align-items:center;
         text-decoration-line:none;
         text-decoration-thickness:initial;
         text-decoration-style:initial;
         text-decoration-color:initial;
       }
       .appel-gjs i{
         margin-right:10px;
       }
       #i4od7{
         display:flex;
         margin:0px 0px 15px 0px;
         font-size:20px;
       }
       #icon-a008f651-9f02-432e-b23a-06918c3a2739{
         margin:0px 14px 0px 0px;
       }
       #imh2x{
         display:inline-block;
         font-size:20px;
       }
       #icon-587a3193-a983-4926-a88e-8e1678f9de4e{
         font-size:45px;
       }
       
      #row-4d13e102-b0c4-486b-a026-b11151b642d9 .owl-theme .owl-dots .owl-dot span{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #row-4d13e102-b0c4-486b-a026-b11151b642d9 .owl-theme .owl-dots .owl-dot.active span, .owl-theme .owl-dots .owl-dot:hover span{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul li::before{
        color:rgb(0, 0, 0);
      }
      #ibo5 ul li a{
        border-top-left-radius:0%;
        border-top-right-radius:0%;
        border-bottom-left-radius:0%;
        border-bottom-right-radius:0%;
        padding-top:15px;
        padding-bottom:15px;
        padding-right:30px;
        margin-top:0px;
        margin-bottom:0px;
        margin-right:0px;
        margin-left:30px;
        font-family:unset;
        color:rgb(0, 0, 0);
        text-align:left;
        font-weight:normal;
        font-size:20px;
        line-height:20px;
        padding-left:0px;
      }
      #ibo5 ul li a:hover{
        color:rgb(0, 0, 0);
      }
      #ibo5 ul li a.active{
        color:rgb(0, 0, 0);
      }
      #ibo5 ul li a:hover::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul li a:hover::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul li a.active::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul li a.active::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul.dropdown-menu{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(238, 238, 238);
      }
      #ibo5 ul.dropdown-menu li a{
        padding-top:15px;
        padding-bottom:15px;
        padding-right:15px;
        padding-left:15px;
        margin-top:0px;
        margin-bottom:0px;
        margin-right:0px;
        margin-left:0px;
        font-family:unset;
        color:rgb(0, 0, 0);
        text-align:left;
        font-weight:normal;
        font-size:16px;
        line-height:16px;
      }
      #ibo5 ul.dropdown-menu li a:hover{
        color:rgb(0, 0, 0);
      }
      #ibo5 ul.dropdown-menu li a.active{
        color:rgb(0, 0, 0);
      }
      #ibo5 ul.dropdown-menu li a:hover::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul.dropdown-menu li a:hover::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul.dropdown-menu li a.active::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul.dropdown-menu li a.active::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul li::before{
        color:rgb(0, 0, 0);
      }
      #ibo5 ul li a:hover::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul li a:hover::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul li a.active::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul li a.active::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul.dropdown-menu li a:hover::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul.dropdown-menu li a:hover::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul.dropdown-menu li a.active::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul.dropdown-menu li a.active::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #i2di{
        width:50%;
        vertical-align:middle;
        padding-top:0px;
        padding-right:0px;
        padding-bottom:0px;
        padding-left:0px;
        text-align:right;
      }
      #ibo5 ul li::before{
        color:rgb(0, 0, 0);
      }
      #ibo5 ul li a:hover::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul li a:hover::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul li a.active::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul li a.active::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul.dropdown-menu li a:hover::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul.dropdown-menu li a:hover::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul.dropdown-menu li a.active::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #ibo5 ul.dropdown-menu li a.active::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      .fb-square{
        fill:rgb(25, 118, 210);
      }
      .fb-font{
        fill:rgb(255, 255, 255);
      }
      .instagram-font{
        fill:rgb(255, 255, 255);
      }
      .instagram-square{
        fill:url("#radial-gradient");
      }
      #irx2f{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgba(0, 0, 0, 0);
        display:flex !important;
        justify-content:center !important;
      }
      #ixfbf{
        width:50%;
        vertical-align:middle;
      }
      #ifgvt{
        width:300px;
      }
      #iyf62{
        position:relative;
        width:250px;
        height:auto;
      }
      #ila4r{
        font-size:20px;
        font-weight:700;
        margin-top:20px;
        margin-right:0px;
        margin-bottom:20px;
        margin-left:0px;
        line-height:25px;
      }
      #igl2fw{
        justify-content:flex-start;
        display:flex !important;
      }
      #igl2fw .owl-theme .owl-dots .owl-dot span{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #igl2fw .owl-theme .owl-dots .owl-dot.active span, .owl-theme .owl-dots .owl-dot:hover span{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #igkhga{
        width:50%;
        vertical-align:middle;
      }
      #icon-3623c40e-da48-45e3-8765-8139c77729a2{
        font-size:45px;
      }
      #irx2f ul li::before{
        color:rgb(0, 0, 0);
      }
      #irx2f ul li a{
        border-top-left-radius:0%;
        border-top-right-radius:0%;
        border-bottom-left-radius:0%;
        border-bottom-right-radius:0%;
        padding-top:15px;
        padding-bottom:15px;
        padding-right:30px;
        padding-left:0px;
        margin-top:0px;
        margin-bottom:0px;
        margin-right:0px;
        margin-left:30px;
        font-family:unset;
        color:rgb(0, 0, 0);
        text-align:left;
        font-weight:normal;
        font-size:20px;
        line-height:20px;
      }
      #irx2f ul li a:hover{
        color:rgb(0, 0, 0);
      }
      #irx2f ul li a.active{
        color:rgb(0, 0, 0);
      }
      #irx2f ul li a:hover::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul li a:hover::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul li a.active::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul li a.active::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul.dropdown-menu{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(238, 238, 238);
      }
      #irx2f ul.dropdown-menu li a{
        padding-top:15px;
        padding-bottom:15px;
        padding-right:15px;
        padding-left:15px;
        margin-top:0px;
        margin-bottom:0px;
        margin-right:0px;
        margin-left:0px;
      }
      #irx2f ul.dropdown-menu li a:hover{
        color:rgb(0, 0, 0);
      }
      #irx2f ul.dropdown-menu li a.active{
        color:rgb(0, 0, 0);
      }
      #irx2f ul.dropdown-menu li a:hover::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul.dropdown-menu li a:hover::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul.dropdown-menu li a.active::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul.dropdown-menu li a.active::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul li::before{
        color:rgb(0, 0, 0);
      }
      #irx2f ul li a:hover::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul li a:hover::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul li a.active::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul li a.active::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul.dropdown-menu li a:hover::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul.dropdown-menu li a:hover::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul.dropdown-menu li a.active::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul.dropdown-menu li a.active::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul li::before{
        color:rgb(0, 0, 0);
      }
      #irx2f ul li a:hover::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul li a:hover::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul li a.active::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul li a.active::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul.dropdown-menu li a:hover::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul.dropdown-menu li a:hover::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul.dropdown-menu li a.active::after{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      #irx2f ul.dropdown-menu li a.active::before{
        background-image:initial;
        background-position-x:initial;
        background-position-y:initial;
        background-size:initial;
        background-repeat-x:initial;
        background-repeat-y:initial;
        background-attachment:initial;
        background-origin:initial;
        background-clip:initial;
        background-color:rgb(0, 0, 0);
      }
      @media (min-width: 768px) and (max-width: 991px){
        #ibo5 ul li a{
          font-size:14px;
          line-height:14px;
        }
        #ibo5 ul li a{
          font-size:14px;
          line-height:14px;
        }
        #ibo5 ul li a{
          font-size:14px;
          line-height:14px;
        }
        #ibo5 ul li a{
          font-size:14px;
          line-height:14px;
        }
        #irx2f ul li a{
          font-size:14px;
          line-height:14px;
        }
      }
      @media (max-width: 767px){
        #ibo5 ul li a{
          font-size:14px;
          line-height:14px;
        }
        #ibo5 ul li a{
          font-size:14px;
          line-height:14px;
        }
        #ibo5 ul.dropdown-menu li a{
          font-size:14px;
          line-height:14px;
        }
        #ibo5 ul li a{
          font-size:14px;
          line-height:14px;
        }
        #irx2f ul li a{
          font-size:14px;
          line-height:14px;
        }
      }
      
      </style>
`,
};
